module.exports = __webpack_public_path__ + "static/media/web logos_FUZE.3589f8e4.jpg";